import { 
  OPEN_MASS_ITEM_LOCATION_MODAL, 
  CLOSE_MASS_ITEM_LOCATION_MODAL,
  SHOW_MASS_ITEM_MESSAGE_MODAL,
  PROCESSING_MASS_CREATE_ITEMS,
  SET_TARGET_LOCATION,
  MASS_CREATE_ITEMS
} from './MassItemLocationModalConstants';

export function openModal() {
  return { type: OPEN_MASS_ITEM_LOCATION_MODAL };
};

export function closeModal() {
  return { type: CLOSE_MASS_ITEM_LOCATION_MODAL };
};

export function setTargetLocation(targetLocationId, targetCurrencyId){
  return { type: SET_TARGET_LOCATION, targetLocationId, targetCurrencyId };
};

export function massCreateItems(data){
  return { type: MASS_CREATE_ITEMS, data };
};

export function showMessageModal() {
  return { type: SHOW_MASS_ITEM_MESSAGE_MODAL, showMessageModal: true };
};

export function hideMessageModal() {
  return { type: SHOW_MASS_ITEM_MESSAGE_MODAL, showMessageModal: false };
};

export function processingMassCreateItem(){
  return { type: PROCESSING_MASS_CREATE_ITEMS, isProcessing: true };
}

export function doneProcessingMassCreateItem(noOfItems){
  return { type: PROCESSING_MASS_CREATE_ITEMS, isProcessing: false, noOfItems };
}
  